import {
  IWorkzone,
  API_PATH_ApiWorkzonesForOfflineUseGet,
  IApiWorkzonesForOfflineUseGetQueryRequest,
  IApiWorkzonesForOfflineUseGetResponse,
} from "mhc-server/dist/interfaces";

import {apiFetch} from "../../../api/apiFetch";

export const apiWorkzonesForOfflineUseGet = async (args: IApiWorkzonesForOfflineUseGetQueryRequest): Promise<IWorkzone[]> => {
  const response = await apiFetch.request<IApiWorkzonesForOfflineUseGetQueryRequest, void, IApiWorkzonesForOfflineUseGetResponse>({
    path: API_PATH_ApiWorkzonesForOfflineUseGet,
    query: args,
  });
  return response.workzones;
};
